import { useAppQuery } from "~/hooks/useAppQuery"
import { getTopic } from "../server/topic.functions"
import { topicHeaderQueryKeys } from "../query-keys"

export function useTopic(id: number) {
  return useAppQuery({
    queryKey: topicHeaderQueryKeys(id),
    queryFn: () => getTopic({ data: { id } }),
    errorMessage: "Не удалось загрузить тему",
  })
}
